import { displayToast, sendAppsignalError } from "../modules/utils";

class Supplementfilter {
  constructor(node) {
    this.element = node;

    this.sortFilterElement = this.element.querySelector(".js-supplement-filter-sort");
    this.contentwrapper = this.element.querySelector(".js-content-wrapper");
    this.countryInputs = this.element.querySelectorAll(".js-country-filter");
    this.languageInputs = this.element.querySelectorAll(".js-language-filter");

    this.fetchUrl = new URL(this.element.dataset.fetchUrl, window.location);

    this.initialize();
  }

  handleChangeEvent(e) {
    const { name, value, checked } = e.target;

    const existingValue = this.fetchUrl.searchParams.get(name);

    if (checked) {
      let newvalue = existingValue ? `${existingValue},${value}` : value;

      this.fetchUrl.searchParams.set(name, newvalue);
    } else {
      const values = existingValue.split(",");
      const updatedValues = values.filter((val) => val !== value);
      this.fetchUrl.searchParams.set(name, updatedValues.join(","));
    }

    this.filterChange();
  }

  initialize() {
    this.countryInputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        this.handleChangeEvent(e);
      });
    });

    this.languageInputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        this.handleChangeEvent(e);
      });
    });

    this.sortFilterElement.addEventListener("change", (e) => {
      const { name, value } = e.target;

      this.fetchUrl.searchParams.set(name, value);

      this.filterChange();
    });
  }

  filterChange() {
    this.contentwrapper.classList.add("is-loading");

    fetch(this.fetchUrl)
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        const { html } = data;

        this.contentwrapper.innerHTML = html;
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "SupplementFilter", {
          response: this.response,
        });
      })
      .finally(() => {
        this.contentwrapper.classList.remove("is-loading");
      });
  }
}

const supplementFilterElement = document.querySelector("[data-js='supplement-filter']");

if (supplementFilterElement) {
  new Supplementfilter(supplementFilterElement);
}
